import { formatCurrency, formatDate, safelyParseFloat } from '@/utils/constants';
import { getPolicyTransactionInvoiceLabel } from '@/utils/policyTransactionLabel';
import { safelyParseDate } from '@/utils/date';
import { Box, Chip, Stack, Typography } from '@mui/material';
import React from 'react';

const getTransactionLabel = (transaction) => {
	const invoiceNumber = getPolicyTransactionInvoiceLabel(transaction);
	const type = transaction?.TransactionType;
	const effectiveDate = safelyParseDate(transaction?.EffectiveDate);
	if (invoiceNumber && type && effectiveDate)
		return `${invoiceNumber} - ${type} (${formatDate(effectiveDate)})`;
	if (invoiceNumber && type) return `${invoiceNumber} - ${type}`;
	return type || invoiceNumber || 'Transaction';
};

const getBalance = (transactions) =>
	transactions.reduce((acc, t) => acc + safelyParseFloat(t.Balance), 0);

const GroupView = ({
	clientId,
	yearFolder,
	dealName,
	transactions = [],
	clientName,
	transactionCount,
	effectiveDate,
}) => {
	const count = transactionCount ?? transactions.length;

	const balance = formatCurrency({ num: getBalance(transactions) });

	return (
		<Box
			sx={{
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 1,
				p: 1.5,
			}}
		>
			<Stack direction='column' spacing={1}>
				<Stack direction='row' justifyContent='space-between' spacing={1}>
					<Typography fontWeight={700}>{clientName}</Typography>
					<Stack direction='row' spacing={2} flexWrap='wrap' useFlexGap>
						<Chip
							size='small'
							label={`${count} transaction${count === 1 ? '' : 's'}`}
						/>
						{effectiveDate && (
							<Typography sx={{ mt: '1.5px' }}>
								{formatDate(effectiveDate)}
							</Typography>
						)}
					</Stack>
				</Stack>
				<Stack direction='row' justifyContent='space-between' spacing={1}>
					<Typography variant='body2' color='text.secondary'>
						{`${dealName}${yearFolder ? ` (${yearFolder})` : ''}`}
					</Typography>
					<Typography variant='body2' color='text.secondary' sx={{ textAlign: 'right' }}>
						{balance}
					</Typography>
				</Stack>

				<Stack direction='row' spacing={1} flexWrap='wrap' useFlexGap sx={{ pt: 1 }}>
					{transactions.map((transaction) => (
						<Chip
							key={`${clientId}-${transaction.Id}`}
							size='small'
							label={getTransactionLabel(transaction)}
						/>
					))}
				</Stack>
			</Stack>
		</Box>
	);
};
GroupView.displayName = 'GroupView';
export default GroupView;
